export default "__VITE_ASSET__CVUnfXyE__"